<section class="sitemap pt-4">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <h2>Sitemap</h2>
            </div>
        </div>

        <div class="">
            <div class="pt-4 pb-3 border-bottom">
                <h4 class="pb-4">About</h4>
                <div class="row">
                    <div class="col-lg-2">
                        <a routerLink="/about">About Us</a>
                    </div>
                    <div class="col-lg-2">
                        <a routerLink="/about">History</a>
                    </div>
                </div>
            </div>

            <div class="pt-4 pb-3 border-bottom">
                <h4 class="pb-4">Services </h4>
                <div class="row">
                    <div class="col-lg-3 col-md-6 border-after">
                        <h5 class="pb-3">Air</h5>
                        <div [routerLink]="['/air-service']" fragment="air-freight">
                            <a href="/air-service#air-freight"><span class="list-number">01.</span>Air Freight</a>
                        </div>
                        <div [routerLink]="['/air-service']" fragment="express">
                            <a href="/air-service#express"><span class="list-number">02.</span>Express</a>
                        </div>
                        <div [routerLink]="['/air-service']" fragment="charter">
                            <a href="/air-service#charter"><span class="list-number">03.</span>Charter</a>
                        </div>
                        <div [routerLink]="['/air-service']" fragment="obc">
                            <a href="/air-service#obc"><span class="list-number">04.</span>On Board Courier</a>
                        </div>
                        <div [routerLink]="['/air-service']" fragment="sea-air">
                            <a href="/air-service#sea-air"><span class="list-number">05.</span>Sea/Air</a>
                        </div>

                    </div>

                    <div class="col-lg-3 col-md-6 border-after border-md-after-none">
                        <h5 class="pb-3">Ocean</h5>
                        <div [routerLink]="['/ocean-service']" fragment="lcl">
                            <a href="/ocean-service#lcl"><span class="list-number">01.</span>Less than Container Load</a>
                        </div>
                        <div [routerLink]="['/ocean-service']" fragment="fcl">
                            <a href="/ocean-service#fcl"><span class="list-number">02.</span>Full Container Load</a>
                        </div>
                        <div [routerLink]="['/ocean-service']" fragment="rail-transport">
                            <a href="/ocean-service#rail-transport"><span class="list-number">03.</span>Rail Transport</a>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 border-after">
                        <h5 class="pb-3">Verticals</h5>
                        <div [routerLink]="['/verticals']" fragment="aviation-logistics">
                            <a href="/verticals#aviation-logistics"><span class="list-number">01.</span>Aviation Logistics</a>
                        </div>

                        <div [routerLink]="['/verticals']" fragment="marine-logistics">
                            <a href="/verticals#marine-logistics"><span class="list-number">02.</span>Marine Logistics</a>
                        </div>

                        <div [routerLink]="['/verticals']" fragment="fasion-logistics">
                            <a href="/verticals#fasion-logistics"><span class="list-number">03.</span>Fashion Logistics</a>
                        </div>

                    </div>

                    <div class="col-lg-3 col-md-6">
                        <h5 class="pb-3">Value Added</h5>
                        <div [routerLink]="['/value-added-service']" fragment="cargo-insurance">
                            <a href="/value-added-service#cargo-insurance"><span class="list-number">01.</span>Cargo Insurance</a>
                        </div>

                        <div [routerLink]="['/value-added-service']" fragment="customs-clearance">
                            <a href="/value-added-service#customs-clearance"><span class="list-number">02.</span>Customs Clearance</a>
                        </div>

                    </div>
                </div>
            </div>

            <div class="pt-4 pb-3 border-bottom">
                <h4 class="pb-4">Apps</h4>
                <div class="row">
                    <div class="col-lg-4">
                        <a routerLink="/container-specification">Container Specification</a>
                    </div>
                    <div class="col-lg-4">
                        <a routerLink="/emission-calculator">Emission Calculator</a>
                    </div>
                    <div class="col-lg-4">
                        <a routerLink="/freight-volume-calculator">Freight Volume Calculator</a>
                    </div>
                    <div class="col-lg-4">
                        <a routerLink="/container-vessel-tracker">Container Vessel Tracker</a>
                    </div>
                    <div class="col-lg-4">
                        <a routerLink="/inco-terms">INCO Terms</a>
                    </div>
                    <div class="col-lg-4">
                        <a routerLink="/shipping-glossary">Shipping Glossary</a>
                    </div>
                </div>
            </div>

            <div class="pt-4 pb-3">
                <h4 class="pb-4">Contact</h4>
                <div class="row">
                    <div class="col-lg-2">
                        <a routerLink="/denmark">Denmark</a>
                    </div>
                    <div class="col-lg-2">
                        <a routerLink="/estonia">Estonia</a>
                    </div>
                    <div class="col-lg-2">
                        <a routerLink="/finland">Finland</a>
                    </div>
                    <div class="col-lg-2">
                        <a routerLink="/norway">Norway</a>
                    </div>
                    <div class="col-lg-2">
                        <a routerLink="/sweden">Sweden</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<router-outlet></router-outlet>